import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import Personalizer from 'personalizer';
import HowToSyncLinkBuilder from 'views/utils/HowToSyncLinkBuilder';
import templateHtml from 'templates/device/ChangesSavedView.html';

var ChangesSavedView = Backbone.View.extend({
    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.message = args.message;
        this.preLocalized = args.preLocalized; // The message being passed in has already been localized
        this.alertType = args.alertType; // 'info' || 'error' || 'success'
    },

    render: function() {
        this.$el.html(
            this.template({
                Localizer: Localizer,
                Personalizer: Personalizer,
                message: this.message,
                preLocalized: this.preLocalized,
                alertType: this.alertType
            })
        );

        if (this.alertType === 'info') {
            this.$('.how-to-sync-link').attr('href', HowToSyncLinkBuilder.getHowToSyncURL());
        }

        this.$el.show();
    }
});

export default ChangesSavedView;
